import React from 'react'
import PropTypes from 'prop-types'
import useViewportBase from './Viewport.hook'

export const useViewport = useViewportBase

/**
 * The Viewport' component.
 */
const Viewport = props => {
  const { children, desktopMatch, largeMatch, mediumMatch, mobileMatch, rule, smallMatch, tinyMatch } = props
  const { size } = useViewport()
  const result = rule(size)

  if (!result) {
    return null
  }

  if (size.isDesktop && desktopMatch) {
    return desktopMatch(size)
  }

  if (size.isLarge && largeMatch) {
    return largeMatch(size)
  }

  if (size.isMedium && mediumMatch) {
    return mediumMatch(size)
  }

  if (size.isMobile && mobileMatch) {
    return mobileMatch(size)
  }

  if (size.isSmall && smallMatch) {
    return smallMatch(size)
  }

  if (size.isTiny && tinyMatch) {
    return tinyMatch(size)
  }

  return <>{children}</>
}

Viewport.defaultProps = {
  children: null,
  desktopMatch: null,
  largeMatch: null,
  mediumMatch: null,
  mobileMatch: null,
  smallMatch: null,
  tinyMatch: null,
  rule: () => true
}

Viewport.propTypes = {
  /**
   * Children.
   */
  children: PropTypes.node,
  /**
   * Desktop match.
   */
  desktopMatch: PropTypes.oneOfType([PropTypes.func, PropTypes.number]),
  /**
   * Large match.
   */
  largeMatch: PropTypes.oneOfType([PropTypes.func, PropTypes.number]),
  /**
   * Medium match.
   */
  mediumMatch: PropTypes.oneOfType([PropTypes.func, PropTypes.number]),
  /**
   * Mobile match.
   */
  mobileMatch: PropTypes.oneOfType([PropTypes.func, PropTypes.number]),
  /**
   * Small match.
   */
  smallMatch: PropTypes.oneOfType([PropTypes.func, PropTypes.number]),
  /**
   * Tiny match.
   */
  tinyMatch: PropTypes.oneOfType([PropTypes.func, PropTypes.number]),
  /**
   * Rule.
   */
  rule: PropTypes.func
}

export default Viewport
